import { useNavigate } from "@solidjs/router";
import { useBillingClient, useCallOptions, withBearerToken } from "@storytell/cp-client";
import { StDropdownItem } from "@storytell/ui/dropdown";
import { TbLogout } from "solid-icons/tb";
import { Show, Suspense } from "solid-js";
import { useWire } from "~/wire";

export const UserAccountPopover = () => {
  const wire = useWire();
  const navigate = useNavigate();

  return (
    <>
      <div class="text-sm font-medium text-secondary-text rounded-md px-2 py-2 pb-1">
        {wire.auth?.user()?.displayName || "You"}
      </div>
      <Show when={wire.auth?.user()?.primaryEmail !== wire.auth?.user()?.displayName}>
        <div class="text-muted-text text-sm px-2 pb-2">{wire.auth?.user()?.primaryEmail}</div>
      </Show>
      <StDropdownItem
        class="cursor-pointer flex items-center gap-3 hover:bg-canvas-hover rounded-md px-2 py-2"
        onClick={async () => {
          if (wire.billing.isFreePlan()) {
            navigate("/pricing");
            return;
          }

          const client = useBillingClient();
          const res = await client.createPortalSession(
            {
              returnUrl: `https://${APP_DOMAIN}/`,
              customerId: wire.auth?.user()?.id,
            },
            useCallOptions(withBearerToken(wire.auth?.token())),
          );
          if (res.isOk() && res.value.session.url) {
            window.location.href = res.value.session.url;
          }
        }}
      >
        <Suspense fallback={<span>Loading...</span>}>
          {wire.billing.isProPlan() ? "Pro Plan (Manage)" : "Explore Plan (Upgrade)"}
        </Suspense>
      </StDropdownItem>
      <StDropdownItem
        onClick={() => wire.auth.methods.signOut()}
        class="cursor-pointer flex items-center gap-3 hover:bg-canvas-hover rounded-md px-2 py-2"
      >
        <TbLogout class="size-5" />
        Sign out
      </StDropdownItem>
    </>
  );
};
